import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ArticleItem = ({
  article: {
    _id,
    header,
    subheader,
    description,
    author,
    category,
    avatar,
    tags
  }
}) => {
  return (
    <div className="profile bg-light">
      <div className="card rounded-0 my-3 shadow-sm">
        <div className="d-flex m-4">
          <div className="ml-3 align-self-center">
            <h5 className="rb mb-0">
              <strong>{header}</strong>
            </h5>
            <p className="my-0 text-muted">by {author}</p>
            {subheader ? (
              <small className="text-muted">
                <i className="fas fa-tags tags"></i> {tags}
              </small>
            ) : (
              <small>No category added</small>
            )}
          </div>
          <Link
            to={`/article/${_id}`}
            className="btn btn-light btn-sm ml-auto align-self-start"
          >
            View Article
          </Link>
        </div>
      </div>
    </div>
  );
};

ArticleItem.propTypes = {
  article: PropTypes.object.isRequired
};

export default ArticleItem;
